import React, { useContext } from 'react';
import SearchBar from '@fiverr-private/search_bar/src';
import I18n from '@fiverr-private/fiverr_context/src/I18n';
import I18nProvider from '@fiverr-private/fiverr_context/src/I18nProvider';
import getSessionLocale from '@fiverr-private/fiverr_context/lib/getSessionLocale';
import getSubCategoryUrl from '../../../utils/url';
import isInSearchBarHighlightTextTest from '../../../utils/experiments/searchBarHighlightTextTest';
import Context from '../../../utils/context';
import { popularSearches, reportBi, BI_TYPE_TAGS } from './config';

import './style.scss';

const TAG_SOURCE = 'hplo_search_tag';

const Header = () => {
    const { ab_tests: abTestsProps } = useContext(Context);

    return (
        <div className="header">
            <h1><I18n k="logged_out_homepage.hero.title"/></h1>
            <I18nProvider>
                {({ i18n }) => {
                    const searchBarParams = {
                        placeholder: i18n.t('logged_out_homepage.hero.logo_animation'),
                        source: 'main_banner',
                        locale: getSessionLocale()
                    };

                    const abTests = {
                        inChangeHighlightTextValueExp: isInSearchBarHighlightTextTest(abTestsProps)
                    };

                    return (
                        <SearchBar {...searchBarParams} abTests={abTests}/>
                    );
                }}
            </I18nProvider>
            <div className="popular">
                <span className="text-body-2"><I18n k="logged_out_homepage.hero.popular"/></span>
                <ul>
                    {
                        popularSearches.map((item, index) => {
                            const pos = index + 1;
                            const subCatParams = {source: TAG_SOURCE, pos, name: item.subCategorySlug};
                            const tagPath = getSubCategoryUrl(item.categorySlug, item.subCategorySlug, subCatParams);

                            return (
                                <li key={index}>
                                    <a href={tagPath}
                                        className="text-body-2"
                                        onClick={() => reportBi(BI_TYPE_TAGS, {position: pos, ...item})}>
                                        <I18n k={`logged_out_homepage.hero.${item.name}`}/>
                                    </a>
                                </li>
                            );
                        })
                    }
                </ul>
            </div>
        </div>
    );
};

export default Header;
